import { Component, OnInit, OnDestroy } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { UrlService } from 'src/app/shared/services/url.service';
import { UrlControl } from 'src/app/shared/models/generic.model';
import { AlertService } from 'src/app/shared/services/alert.service';
import { GlobalService } from 'src/app/shared/global.service';
import { Router, ActivatedRoute } from '@angular/router';
import { UtilService } from 'src/app/shared/services/util.service';
import { AdministrarFuncionarioDTO, VehiculoFuncionario } from 'src/app/models/administrarFuncionario.model';
import { ConstantesService } from 'src/app/shared/services/constantes.service';
import { ConfirmationModalOptions } from 'src/app/shared/models/modal.model';
import { DominiosService } from 'src/app/shared/services/dominios.service';
import { DetalleDominio } from 'src/app/models/detalleDominio.Model';
import { AppSettings } from 'src/app/app.settings';
import { VariablesZonaCompartida } from 'src/app/shared/services/VariablesZonaCompartida';

@Component({
    selector: 'app-administrar-funcionarios',
    templateUrl: './administrar-funcionarios.component.html',
    styleUrls: ['./administrar-funcionarios.component.scss']
})
export class AdministrarFuncionariosComponent implements OnInit, OnDestroy {

    public urlFTP;
    public tipoDocumento: string;
    public numeroDocumento: string;
    public datosFuncionario: AdministrarFuncionarioDTO;
    public modalOptionsGuardar: ConfirmationModalOptions;
    public deshabilitado = false;
    public rolUsuario: string;
    public existeFuncionario = false;
    public correoInvalido = false;
    public habilitarBotonReenvioCorreo: boolean;
    public isTecnologia = false;
    public isSGA = false;
    public isTH = false;
    private tiempo: NodeJS.Timer;
    private listaDominios = [DominiosService.DOMINIO_TIPO_IDENTIFICACION, DominiosService.DOMINIO_CARGO_FUNCIONARIO,
    DominiosService.DOMINIO_SEDE, DominiosService.DOMINIO_TIPO_VINCULACION
    ];
    public dominios: DetalleDominio[];

    public listaVehiculos: VehiculoFuncionario[] = [];
    constructor(
        private router: Router,
        private spinner: NgxSpinnerService,
        private urlService: UrlService,
        private alertService: AlertService,
        private global: GlobalService,
        private utilService: UtilService,
        public route: ActivatedRoute) {
        this.urlFTP = sessionStorage.getItem(ConstantesService.FTP_SESSSION);
        this.rolUsuario = sessionStorage.getItem(ConstantesService.ROL_SESSION);
        this.modalOptionsGuardar = new ConfirmationModalOptions(
            'Confirmación',
            ConstantesService.MSJ_CONF_GUARDAR_FUNCIONARIO,
            'SI', 'NO', 'fa fa-save', true, false, 'Guardar', null, 'btn btn-secondary');
    }

    procesoValidacion() {
        if (this.datosFuncionario) {
            this.modalOptionsGuardar.disabled = !this.validarCampos();
        }
        this.tiempo = setTimeout(() => {
            this.procesoValidacion();
        }, 500);
    }

    ngOnInit() {
        this.consultarDominios();
    }

    iniciarPantalla() {
        const datos = this.global.zonaCompartida[VariablesZonaCompartida.DATOS_FUNCIONARIO];
        this.tipoDocumento = datos ? datos.tipoDocumento : null;
        this.numeroDocumento = datos ? datos.numDocumento : null;
        if (this.tipoDocumento && this.numeroDocumento) {
            this.datosFuncionario = undefined;
            this.existeFuncionario = true;
            this.consultarFuncionario();
        } else {
            this.datosFuncionario = new AdministrarFuncionarioDTO();
            this.datosFuncionario.urlFoto = this.obtenerUrlFoto(undefined);
            this.datosFuncionario.registraHuella = false;
            this.validarEdicion();
            this.habilitarBotonCorreo();
        }
        this.procesoValidacion();
    }

    public consultarDominios() {
        this.spinner.show();
        const serviceProvider = 'consultarDominios';
        const url = this.urlService.getUrlTransversal(new UrlControl(serviceProvider, null, null), AppSettings.API_INIT_ENDPOINT);
        this.global.postGenerico(url, this.listaDominios).subscribe(
            data => {
                this.dominios = data;
                this.iniciarPantalla();
                this.spinner.hide();
            }, (err: any) => {
                this.cathException('Ocurrio un error en la consulta de los dominios');
            }
        );
    }

    validarEdicion() {
        // tslint:disable: triple-equals
        this.deshabilitado = this.rolUsuario == DominiosService.ROL_ADMINISTRADOR_TEC
            || (this.existeFuncionario &&
                ((this.rolUsuario == DominiosService.ROL_ADMINISTRADOR_TH
                    && this.datosFuncionario.tipoVinculacion == DominiosService.TIPO_VINCULACION_CONTRATISTA)
                    || (this.rolUsuario == DominiosService.ROL_ADMINISTRADOR_SGA
                        && this.datosFuncionario.tipoVinculacion != DominiosService.TIPO_VINCULACION_CONTRATISTA)
                        && this.datosFuncionario.tipoVinculacion != DominiosService.TIPO_VINCULACION_TERCERO))
                        
                        || (this.rolUsuario == DominiosService.ROL_ADMINISTRADOR_TH 
                            && this.datosFuncionario.tipoVinculacion == DominiosService.TIPO_VINCULACION_TERCERO  );

        this.isTecnologia = this.rolUsuario == DominiosService.ROL_ADMINISTRADOR_TEC;
        this.isSGA = this.rolUsuario == DominiosService.ROL_ADMINISTRADOR_SGA;
        this.isTH = this.rolUsuario == DominiosService.ROL_ADMINISTRADOR_TH;
    }

    /**
     * Método que recibe el evento de confirmación de edición de elementos y ejecuta la actualización
     * @param event Objeto que contiene la respuesta del usuario (Si o No)
     */
    public getConfirmationGuardar(event) {
        if (event[0]) {
            this.convertirNombresFuncionario();
            this.agregarCamposllenos();
        }
    }

    public validarCampos(): boolean {
        let valido: boolean;
        switch (this.rolUsuario) {
            case DominiosService.ROL_ADMINISTRADOR_TH:
                valido = this.validarDatosVinculacion()
                && this.validarCamposPersonal()
                && this.validarCamposContacto()
                && this.validarDatosSaludPension()
                && this.validarDatosContrato()
                && this.validarDatosJefe()
                && this.validarDatosCorreo();
                break;
            case DominiosService.ROL_ADMINISTRADOR_SGA:
                valido = this.validarDatosVinculacion()
                && this.validarCamposPersonal()
                && this.validarCamposContacto()
                && this.validarDatosSaludPension()
                && this.validarDatosContrato()
                && this.validarDatosJefe()
                && this.validarDatosCorreo()
                && this.validarDatosVehiculo();
                break;
            default:
                valido = this.validarDatosCorreo();
        }
        return valido;
    }

    convertirNombresFuncionario() {
        const valor = this.utilService.separarString(this.datosFuncionario.nombres.trim());
        const valor1 = this.utilService.separarString(this.datosFuncionario.apellidos.trim());
        this.datosFuncionario.nombreCompleto = this.datosFuncionario.nombres.trim() + ' ' + this.datosFuncionario.apellidos.trim();
        this.datosFuncionario.primerNombre = valor[0] ? valor[0].trim() : valor[0];
        this.datosFuncionario.segundoNombre = valor[1] ? valor[1].trim() : valor[1];
        this.datosFuncionario.primerApellido = valor1[0] ? valor1[0].trim() : valor1[0] ;
        this.datosFuncionario.segundoApellido = valor1[1] ? valor1[1].trim() : valor1[1];
    }

    validarDatosVinculacion() {
        return this.utilService.validarCamposObligatorios(this.datosFuncionario.tipoVinculacion)
            && this.utilService.validarCamposObligatorios(this.datosFuncionario.estado);
    }

    validarCamposPersonal() {
        return this.utilService.validarCamposObligatorios(this.datosFuncionario.nombres)
            && this.utilService.validarCamposObligatorios(this.datosFuncionario.apellidos)
            && this.utilService.validarCamposObligatorios(this.datosFuncionario.tipoDocumento)
            && this.utilService.validarCamposObligatorios(this.datosFuncionario.numDocumento);
    }

    validarCamposContacto() {
        return this.utilService.validarCamposObligatorios(this.datosFuncionario.correoPersonal) ? 
            !this.utilService.validarCorreo(this.datosFuncionario.correoPersonal)
            : true;
    }

    validarDatosSaludPension() {
        return true;
    }

    validarDatosContrato() {
        return this.utilService.validarCamposObligatorios(this.datosFuncionario.cargo);
    }

    validarFechasVinculacion() {
        const fechaInicio = typeof this.datosFuncionario.fechaInicioVinculacion === 'string'
            ? new Date(this.datosFuncionario.fechaInicioVinculacion) : this.datosFuncionario.fechaInicioVinculacion;
        const fechaFin = typeof this.datosFuncionario.fechaFinVinculacion === 'string'
            ? new Date(this.datosFuncionario.fechaFinVinculacion) : this.datosFuncionario.fechaFinVinculacion;
        const fechasValidas = fechaFin.getTime() >= fechaInicio.getTime();
        if (!fechasValidas) {
            this.alertService.generateAlertError('La fecha de fin de vinculación debe ser mayor a la fecha de inicio', '');
        }

        return fechasValidas;
    }

    validarDatosJefe() {
        return this.utilService.validarCamposObligatorios(this.datosFuncionario.dependencia)
            && this.utilService.validarCamposObligatorios(this.datosFuncionario.instalacion);
    }

    validarDatosVehiculo() {
        return this.utilService.validarCamposObligatorios(this.datosFuncionario.autorizacionBicicleta);
    }

    validarDatosIngreso() {
        return this.datosFuncionario.registraHuella
            ? this.datosFuncionario.registraHuella : this.utilService.validarCamposObligatorios(this.datosFuncionario.tarjetaIngreso);
    }

    validarDatosCorreo() {
        return this.utilService.validarCamposObligatorios(this.datosFuncionario.correoMen) ? 
            !this.utilService.validarCorreo(this.datosFuncionario.correoMen)
            : true
            && !this.correoInvalido;
    }

    /**
     * Método que valida si el correo ingresado es valido
     * @author jnmartinez
     */
    validarCorreo(opcion: number) {
        if (opcion === 1) {
            this.correoInvalido = this.utilService.validarCamposObligatorios(this.datosFuncionario.correoMen) ?
                this.utilService.validarCorreo(this.datosFuncionario.correoMen)
                : false;
        } else {
            return !this.utilService.validarCorreo(this.datosFuncionario.correoPersonal);
        }
    }

    /**
     * regresa al listado de funcionarios
     * @author fromero
     */
    regresarListaFuncionarios() {
        this.global.zonaCompartida[VariablesZonaCompartida.DATOS_FUNCIONARIO] = undefined;
        this.router.navigate(['main/administrar-funcionarios']);
    }

    agregarCamposllenos() {
        this.datosFuncionario.rolUsuario = this.rolUsuario;
        this.guardarInformacionFuncionario();
    }

    /**
     * Método hace el llamado al back para realizar el guardado
     */
    guardarInformacionFuncionario() {
        this.spinner.show();
        let serviceProvider: string;
        serviceProvider = 'guardarInformacionFuncionario';
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null), this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postGenerico(url, this.datosFuncionario).subscribe(
            data => {
                this.alertService.generateAlertSuccess('Se registró información de funcionario exitosamente', '');
                this.spinner.hide();
                if (this.isSGA || this.isTH) {
                    this.validarVehiculos();
                } else {
                    this.actualizarPantalla();
                }

            }, err => {
                this.spinner.hide();
                this.cathException('No es posible Guardar la información de funcionario');
            }
        );
    }

    /**
     * Método que realiza la consulta del funcionario
     */
    consultarFuncionario() {
        const entorno = this;
        this.spinner.show();
        let serviceProvider: string;
        serviceProvider = 'consultarInformacionFuncionario';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['tipoDocumento', this.urlService.encodeURI(this.tipoDocumento)]);
        queryParams.push(['numeroDocumento', this.urlService.encodeURI(this.numeroDocumento)]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postGenerico(url).subscribe(
            data => {
                this.datosFuncionario = data[0];
                this.actualizarDatosFuncionario();
                this.habilitarBotonCorreo();
                this.consultarVehiculos();
                this.validarEdicion();
                entorno.modalOptionsGuardar.disabled = !entorno.validarCampos();
            }, err => {
                this.spinner.hide();
                this.cathException('No es posible consultar la información del funcionario');
            }
        );
    }

    actualizarDatosFuncionario() {
        this.datosFuncionario.nombres = this.datosFuncionario.primerNombre;
        if (this.datosFuncionario.segundoNombre) {
            this.datosFuncionario.nombres = this.datosFuncionario.nombres.concat(' ')
                .concat(this.datosFuncionario.segundoNombre).trim();
        }
        this.datosFuncionario.apellidos = this.datosFuncionario.primerApellido;
        if (this.datosFuncionario.segundoApellido) {
            this.datosFuncionario.apellidos = this.datosFuncionario.apellidos.concat(' ')
                .concat(this.datosFuncionario.segundoApellido).trim();
        }
        this.datosFuncionario.urlFoto = this.obtenerUrlFoto(this.datosFuncionario.urlFotoFuncionario);
        if (!this.datosFuncionario.progreso) {
            this.datosFuncionario.progreso = 0;
        }
    }

    /**
     * Metodo encargado de colocar la foto de la persona o en dicha caso que no tenga
     * coloca la foto por defecto
     */
    public obtenerUrlFoto(url: string): string {
        if (this.urlFTP && this.urlFTP !== '' && url) {
            return this.urlFTP + url;
        } else {
            return 'assets/img/user-male-icon.png';
        }
    }

    /**
     * @author klagos@asesoftware.com
     * Método que llama al servicio para realizar la creacion de vehiculos
     */
    validarVehiculos() {
        if (this.listaVehiculos.length > 0) {
            this.listaVehiculos = this.listaVehiculos.filter(x => x.idVehiculo || x.estado == DominiosService.ESTADO_VEHICULO_ACTIVO);
            for (const vehiculo of this.listaVehiculos) {
                vehiculo.numeroIdFuncionario = this.datosFuncionario.numDocumento;
                vehiculo.tipoIdFuncionario = this.datosFuncionario.tipoDocumento;
                vehiculo.fechaModificacion = new Date();
                vehiculo.usuarioModificacion = sessionStorage.getItem(ConstantesService.SIA3_SESSSION);
            }
            this.gestionarVehiculos();
        } else {
            this.actualizarPantalla();
        }
    }

    actualizarPantalla() {
        if (this.existeFuncionario) {
            setTimeout(() => {
                this.iniciarPantalla();
            }, 500);
        } else {
            this.global.zonaCompartida[VariablesZonaCompartida.DATOS_FUNCIONARIO] = {
                numDocumento: this.datosFuncionario.numDocumento,
                tipoDocumento: this.datosFuncionario.tipoDocumento
            };
            this.router.navigate(['/main/administrar-funcionarios/registro']);
            this.iniciarPantalla();
        }
    }

    gestionarVehiculos() {
        this.spinner.show();
        const serviceProvider = 'gestionarVehiculos';
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, null),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postGenerico(url, this.listaVehiculos).subscribe(
            data => {
                this.actualizarPantalla();
                this.spinner.hide();
            }, err => {
                this.actualizarPantalla();
                this.cathException('No fue posible eliminar los vehiculos.');
            }
        );
    }

    /*
     * Metodo encargado de habilitar el boton de enviar correo
     */
    habilitarBotonCorreo() {
        this.habilitarBotonReenvioCorreo = this.existeFuncionario &&
            ((this.rolUsuario == DominiosService.ROL_ADMINISTRADOR_TH
                && this.datosFuncionario.tipoVinculacion == DominiosService.TIPO_VINCULACION_CONTRATISTA)
                || (this.rolUsuario == DominiosService.ROL_ADMINISTRADOR_SGA
                    && this.datosFuncionario.tipoVinculacion != DominiosService.TIPO_VINCULACION_CONTRATISTA));
    }

    /**
     * Metodo encargado de Reenviar el correo
     */
    reenvioCorreo() {
        this.spinner.show();
        let serviceProvider: string;
        serviceProvider = 'enviarCorreoElectronicoCargueFotoARL';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push(['tipoDocumento', this.urlService.encodeURI(this.datosFuncionario.tipoDocumento)]);
        queryParams.push(['numeroDocumento', this.urlService.encodeURI(this.datosFuncionario.numDocumento)]);
        const url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null, queryParams),
            this.urlService.hostAPI_FUNCIONARIOS);
        this.global.postGenerico(url).subscribe(
            data => {
                this.spinner.hide();
            }, err => {
                this.utilService.cathException(err, this.alertService, this.spinner);
            }
        );
    }

    limpiarTarjeta() {
        if (this.datosFuncionario.registraHuella) {
            this.datosFuncionario.tarjetaIngreso = undefined;
        }
    }

    /**
     * Método de control de Excepciones
     * @param error mensaje saliente respecto al error ocurrido
     */
    cathException(error) {
        this.alertService.generateAlertError(error, 'Error');
        this.spinner.hide();
    }

    ngOnDestroy() {
        clearTimeout(this.tiempo);
    }

    /**
     * @author klagos@asesoftware.com
     * Método que llama al servicio para realizar la consulta de vehiculos
     */
    consultarVehiculos() {
        this.spinner.show();
        const serviceProvider = 'consultarVehiculos';
        const queryParams: Array<[string, string]> = new Array<[string, string]>();
        queryParams.push([
            'filterBy',
            this.urlService.encodeURI('tipoIdFuncionario=' + this.datosFuncionario.tipoDocumento
                + '&' + 'numeroIdFuncionario=' + this.datosFuncionario.numDocumento)]);
        let url = this.urlService.getUrlFuncionario(new UrlControl(serviceProvider, null,
            queryParams), this.urlService.hostAPI_FUNCIONARIOS);
        url = url + '&orderBy=ordenVehiculo$DESC';
        this.global.getGenerico(url).subscribe(
            data => {
                this.listaVehiculos = data;
                this.spinner.hide();
            }, err => {
                this.utilService.cathException('No fue posible Cargar los vehiculos', this.alertService, this.spinner);
            }
        );
    }
}
